// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluationClaimCard-cls1_t8f","cls2":"EvaluationClaimCard-cls2_969 EvaluationClaimCard-cls1_t8f"};